import { Theme } from '@material-ui/core/styles';
import { createStyles, CSSProperties } from '@material-ui/styles';

const wrapper: CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  alignItems: 'center',
};

export default ({ palette, spacing }: Theme) =>
  createStyles({
    bottomWrapper: {
      ...wrapper,
      flexDirection: 'row',
      width: '100%',
    },
    title: {
      fontSize: '1.5rem',
      textAlign: 'center',
      marginBottom: spacing(1.5),
    },
    subtitle: {
      fontSize: '1rem',
      textAlign: 'center',
      marginBottom: spacing(4),
      whiteSpace: 'pre-line',
    },
    content: {
      ...wrapper,
      minHeight: '100%',
      flex: 1,
    },
  });
